import translate from '../../translations'

export default data => {
  const str = `
    <div class="card__visual">
      <img src="${
  data.imgSrc
    ? data.imgSrc
    : 'https://res.cloudinary.com/gifas/image/upload/v1593530251/visu-3_xhp7dg.jpg'
}" alt="">
    </div>
    <div class="card__inner">
      <div class="card__top">
        <div class="card__heading">
          <span>
             ${data.tag}
          </span>
          <span class="card__date">
            ${data.date}
          </span>
         </div>
         <div class="card__content">
          <a href="${data.url}">
            <h2 class="card__title">${data.title}</h2>
          </a>
          <div class="card__text">
            ${data.desc}
          </div>
         </div>
        </div>
        <div class="card__bottom">
          <a href="${
  data.url
}" target="_blank" class="link link--medium link--blue-light" rel="nofollow">
            ${translate('READ_NEWS')}
          </a>
        </div>
      </div>`

  return str
}
